import { useParams } from "react-router";

import InterventionsTable from "@/components/ListTable/InterventionsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import {
  INTERVENTIONS_FILTERS,
  INTERVENTIONS_INCLUDES,
} from "@/entities/interventions";
import { ListProvider } from "@/modules/list";

const TabInterventions = () => {
  const { id } = useParams();

  return (
    <ListProvider
      model="interventions"
      storageKey={STORAGE_KEYS.USERS_INTERVENTIONS}
      includes={[INTERVENTIONS_INCLUDES.USERS]}
      hiddenFilters={{ [INTERVENTIONS_FILTERS.USERS_ID]: id }}
    >
      <InterventionsTable
        showLocationColumn
        showAssetColumn
        showBatchMode={false}
        hiddenColumns={["users.id"]}
      />
    </ListProvider>
  );
};

export default TabInterventions;
